module.exports = __webpack_public_path__ + "static/media/next_icon.3c00e4a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/FrontPg/assets/next_icon.svg
// module id = 1398
// module chunks = 0 1 2 3